import {ReactElement} from 'react'
import {Trans} from 'react-i18next'

import {useStyles} from './styles'
import messages from '../../../../assets/messages'

function WarningWithdrawalSection(): ReactElement {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <Trans {...messages.warningAccountActivityDetected} />
      </div>
      <div className={classes.body}>
        <Trans {...messages.itAppearsThatYouHaveOpenPositions} />
        <ul>
          <li><Trans {...messages.youMayExperienceAStopOut} /></li>
          <li><Trans {...messages.yourBonusMayBeForfeited} /></li>
        </ul>
        <Trans {...messages.makeSureYouUnderstandTheImplicationsBeforeProceeding} />
      </div>
    </div>
  )
}

export {WarningWithdrawalSection}
